import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isDevAuthBypassEnabled } from '@/app/devMode';
import { AppShellSkeleton } from '@/layouts/MainLayout/AppShellSkeleton';
import { stashReturnTo } from '@/utils/return-to';

export function ProtectedLayout() {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();
  const effectiveIsAuthenticated = isAuthenticated || isDevAuthBypassEnabled;

  if (isLoading && !isDevAuthBypassEnabled) {
    return <AppShellSkeleton />;
  }

  if (!effectiveIsAuthenticated) {
    // Remember where they were headed so we can restore it after sign-in (deep-link preservation).
    stashReturnTo(location.pathname + location.search);
    return <Navigate to="/" replace />;
  }

  // Render child routes via Outlet
  return <Outlet />;
}
